module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/wx61vr/tc-custom/9781631942655.jpg?1705766049578",
      "alt": "This image is the cover for the book Past Master"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Past Master\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("An expatriate U.S. Civil War veteran and sheriff turned novelist living in Edwardian London follows a deadly trail in search of a missing box.")])]), _c('p', [_vm._v(" It’s true that Denton and Henry James are both American writers now living in London, but they have little else in common: James has the gravitas (and perhaps the pomposity) of a living legend, master of the literary kingdom, while Denton . . . well, he’s scruffy and often covered in dog hair. But he does have this knack for sorting out problems, and James has just such a problem. There was a box, you see, and now it’s gone missing, and in the box were certain letters that, if made public, could be most embarrassing. Most embarrassing indeed.  ")]), _c('p', [_c('b', [_vm._v("Praise for the Denton Mysteries")])]), _c('p', [_c('b', [_vm._v("“Cameron . . . paints a striking portrait of London, and Denton is a hero whose unheroic side only makes his character more appealing.” —"), _c('i', [_vm._v("Kirkus Reviews")]), _vm._v(" on "), _c('i', [_vm._v("The Frightened Man")])])]), _c('b', [_vm._v("“This is no dry, stuffy, repressed Edwardian depiction of events. There are beautiful, concise and accurate descriptions, comedy scenes and credible characters in this novel, which skillfully combines mystery and ")]), _c('b', [_vm._v("history. ”—Historical Novel Society on "), _c('i', [_vm._v("The Second Woman")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kenneth Cameron\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Felony & Mayhem\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0